import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMasterPartnerAuth } from '../contexts/MasterPartnerAuthContext';
import { Loader2 } from 'lucide-react';

const MasterPartnerProtectedRoute = ({ children }) => {
  const { masterPartner, loading } = useMasterPartnerAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!masterPartner) {
    return <Navigate to="/master-partner/login" state={{ from: location }} replace />;
  }

  return children;
};

export default MasterPartnerProtectedRoute;
